const inputFileTypemap = {
  // Big 4 browser supported mime types only
  'image': ['image/apng', 'image/gif', 'image/x-icon', 'image/jpeg', 'image/png', 'image/svg+xml', 'image/webp'],
  'audio': ['audio/webm', 'audio/mpeg', 'audio/mp4', 'audio/flac'],
  'video': ['video/webm', 'video/mpeg', 'video/mp4'],
  // specific formats
  'csv': ['text/csv'],
  'pdf': ['application/pdf'],
  'document': ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/rtf'],
};
const inputFileTypes = Object.keys(inputFileTypemap);
const vFile = (value) => (value instanceof File) ? undefined : 'true';

export { inputFileTypemap as a, inputFileTypes as i, vFile as v };
